import { DataBean } from "../DataBean";

export class Constants extends DataBean {


    public async getProcessTypeConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProcessTypeConstants_Number", [id]);
    }


}